import {
	Component,
	OnInit,
	OnDestroy,
	Input,
	Output,
	EventEmitter,
	ViewChild,
} from '@angular/core';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { AlertService } from '../../_alert';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { DatastoreService } from '../../services/datastore.service';
import {
	availableSlotsForDisplay,
	citizenshipAttendeesAnswer,
	citizenshipPartySize,
	hasCapacityForParty,
} from '../../services/citizenship-capacity';
import { CitizenshipPlacesService } from '../../services/citizenship-places.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CalendarService } from '../../services/calendar.service';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DepartmentService } from '../../services/jrni/department.service';
import { ConfigService } from '../../services/config.service';
import { AppConfig } from '../../app.config';
import { ApiService } from '../../services/jrni/api.service';
import { CustomMatCalendarHeaderComponent } from '@bookinglab/ui';
import { CALENDAR_HEADER_CONFIG } from '@bookinglab/ui';

@Component({
	selector: 'app-mat-calendar',
	templateUrl: './mat-calendar.component.html',
	styleUrls: ['./mat-calendar.component.scss'],
	viewProviders: [
		{
			provide: CALENDAR_HEADER_CONFIG,
			useValue: { disableYearButtons: true },
		},
	],
})
export class MatCalendarComponent implements OnInit, OnDestroy {
	minDate;
	maxDate;
	selectedDate: Date;
	currentDate: Date;
	slots: any[] = [];
	selectedSlot;
	endTime;
	availableDays: any;
	selectedLocation: any;
	adminToggleDateRestrictions = false;
	customHeader = CustomMatCalendarHeaderComponent;
	@Input() service: any;
	@Input() location: any;
	@Input() component: any;
	@Input() date: Date;
	@Input() slotSelectionError: boolean;
	@Output() selectSlotUpdate = new EventEmitter<any>();
	@Output() nextClicked = new EventEmitter<any>();
	calendar: MatCalendar<Date>;
	// The calendar only exists once the days have loaded (it is inside an *ngIf).
	@ViewChild('calendar', { static: false }) set calendarRef(calendar: MatCalendar<Date>) {
		this.calendar = calendar;
		this.calendarSub?.unsubscribe();
		// Wait a tick: stateChanges can fire while Angular is still updating the page.
		this.calendarSub = calendar?.stateChanges.subscribe(() => setTimeout(() => this.onMonthChange()));
	}
	startDate: Date;
	private calendarSub: Subscription;
	private destroy$ = new Subject<void>();
	private slotsRun = 0;
	private destroyed = false;
	config: any;
	calendarError: string;
	adminJourney: any;
	birth_registration_service = false;
	marriage_service = false;
	death_service = false;
	birth_declaration_service = false;
	death_declaration_service = false;
	showFa = false;
	showCalendar = false;
	loadingCalendar = false;

	constructor(
		private availabilityService: AvailabilityService,
		private alertService: AlertService,
		public translateService: TranslateService,
		private spinner: NgxSpinnerService,
		private datastoreService: DatastoreService,
		private calendarService: CalendarService,
		private departmentService: DepartmentService,
		private configService: ConfigService,
		private dateAdapter: DateAdapter<Date>,
		private apiService: ApiService,
		private citizenshipPlaces: CitizenshipPlacesService
	) { }

	async ngOnInit() {
		moment.updateLocale('en', {
			week: {
				dow: 1,
			},
		});
		if (this.datastoreService.selectedSlot) {
			this.selectedSlot =
				this.availabilityService.getSelectedSlot()['__zone_symbol__value'];

			console.log('oninit selectedslot : ', this.selectedSlot);
		}
		this.spinner.show();
		// Set the current date to today for the calendar to default to today
		this.config = await this.apiService.getConfig();
		this.adminJourney = this.datastoreService.adminJourney;
		this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(async (event) => {
			this.dateAdapter.setLocale(event.lang);
			this.prepareDates();
			await this.calendarRun();
			if (this.selectedSlot) {
				this.selectSlot(this.selectedSlot);
			}
		});

		// The calendar page hides the global spinner when its own calls return, which can be before the
		// group places are checked. Keep it up until the calendar is ready.
		this.spinner.getSpinner('primary').pipe(takeUntil(this.destroy$)).subscribe((state) => {
			if (!state.show && this.loadingCalendar) {
				this.spinner.show();
			}
		});

		this.calendarService.onLocationChange.pipe(takeUntil(this.destroy$)).subscribe(async (location) => {
			this.location = location;
			this.citizenshipPlaces.reset();
			await this.calendarRun();
			if (this.selectedSlot) {
				this.selectSlot(this.selectedSlot);
			}
			this.prepareDatesAfterUpdate();
		});

		this.reRun();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		this.calendarSub?.unsubscribe();
		this.citizenshipPlaces.reset();
		this.destroyed = true;
	}

	reRun() {
		this.birth_registration_service = false;
		this.marriage_service = false;
		this.death_service = false;
		this.birth_declaration_service = false;
		this.death_declaration_service = false;

		if (this.adminJourney) {
			this.adminToggleDateRestrictions = !this.adminToggleDateRestrictions;
			this.spinner.show();
		}

		this.prepareDates();
		// The admin override can change the date range.
		this.citizenshipPlaces.reset();

		(async () => {
			await this.calendarRun();
			if (this.selectedSlot) {
				this.selectSlot(this.selectedSlot);
			}
		})();
	}

	prepareDates() {
		this.currentDate = new Date();
		if (!this.selectedDate) {
			this.selectedDate = this.currentDate;
		}
		if (this.date) {
			this.selectedDate = this.date;
		}
		this.prepareDatesAfterUpdate();
	}

	prepareDatesAfterUpdate() {
		const selectedServiceId = this.datastoreService.selectedService.global_id;

		if (this.adminJourney) {
			const minAdvTime = new Date(this.service.min_advance_datetime);
			this.minDate = moment(minAdvTime).add(4, 'minutes').toDate();
			this.maxDate = new Date(this.service.max_advance_datetime);
			if (this.datastoreService.isCitizenshipRoute) {
				if (this.datastoreService.reference) {
					if (this.datastoreService.reference?.required_by_date) {
						this.maxDate = moment(this.datastoreService.reference?.required_by_date);
						console.log('MaxDate set to required by date:', moment(this.datastoreService.reference?.required_by_date).format('YYYY-MM-DD'));
					}
				}
			}
			return;
		}

		const { journey_config } = this.config;

		if (
			journey_config.appointments.birth_registration_services.includes(
				selectedServiceId
			)
		) {
			this.birth_registration_service = true;
			const dob = moment(this.datastoreService.childDob);
			// if the date of birth is more than 42 days ago then we cannot book online
			if (moment().diff(dob, 'days') > 42) {
				console.log('Birth registration service - more than 42 days');
			} else {
				this.minDate = moment(dob).add(0, 'days').add(4, 'minutes').toDate();
				this.maxDate = moment(dob).add(42, 'days').toDate();
				this.calendarError = undefined;
				return;
			}
		}

		if (
			journey_config.appointments.birth_declaration_services.includes(
				selectedServiceId
			)
		) {
			this.birth_declaration_service = true;
			const dob = moment(this.datastoreService.childDob);
			this.minDate = moment(dob).add(35, 'days').add(4, 'minutes').toDate();
			this.maxDate = moment(dob).add(42, 'days').toDate();
			this.calendarError = undefined;
			return;
		}

		if (
			journey_config.appointments.marriage_services.includes(selectedServiceId)
		) {
			this.marriage_service = true;
			const ceremony = moment(this.datastoreService.ceremonyDate);
			this.minDate = moment(ceremony)
				.subtract(6, 'months')
				.add(4, 'minutes')
				.toDate();
			this.maxDate = moment(ceremony).subtract(39, 'days').toDate();
			this.calendarError = undefined;
			return;
		}

		if (journey_config.appointments.death_services.includes(selectedServiceId)) {
		  this.death_declaration_service = true;
		  // const deathDate = moment(this.datastoreService.deathDate);
		  // this.minDate = deathDate.toDate();
      this.minDate = moment().toDate();
		  // this.maxDate = deathDate.add(6, 'days').add(4, 'minutes').toDate();
		  this.maxDate = moment().add(6, 'days').add(4, 'minutes').toDate();
      // this.maxDate = this.addBusinessDays(moment(), 6).add(4, 'minutes').toDate();
		  console.log("Death service min/max");
		  console.log(this.minDate);
		  console.log(this.maxDate);
		  this.calendarError = undefined;
		  return;
		}

    if (journey_config.appointments.death_declaration_services.includes(selectedServiceId)) {
		  this.death_declaration_service = true;
		  // const deathDate = moment(this.datastoreService.deathDate);
		  // this.minDate = deathDate.toDate();
      this.minDate = moment().toDate();
		  // this.maxDate = deathDate.add(6, 'days').add(4, 'minutes').toDate();
		  this.maxDate = moment().add(6, 'days').add(4, 'minutes').toDate();
      // this.maxDate = this.addBusinessDays(moment(), 6).add(4, 'minutes').toDate();
		  console.log("Death dec min/max");
		  console.log(this.minDate);
		  console.log(this.maxDate);
		  this.calendarError = undefined;
		  return;
		}

		// 🔹 DEFAULT: fallback to system-configured min/max
		const minAdvTime = new Date(this.service.min_advance_datetime);
		this.minDate = moment(minAdvTime).add(4, 'minutes').toDate();
		this.maxDate = new Date(this.service.max_advance_datetime);
		if (this.datastoreService.isCitizenshipRoute) {
			if (this.datastoreService.reference) {
				if (this.datastoreService.reference?.required_by_date) {
					this.maxDate = moment(this.datastoreService.reference?.required_by_date);
					console.log('MaxDate set to required by date:', moment(this.datastoreService.reference?.required_by_date).format('YYYY-MM-DD'));
				}
			}
		}

		if (this.datastoreService.dateCapInitDate) {
			const { d, m, y } = this.datastoreService.dateCapInitDate;
			const capDate = moment(`${y}-${m}-${d}`, 'YYYY-MM-DD')
				.add(1, 'year')
				.add(1, 'day')
				.endOf('day');
			if (capDate.isBefore(this.maxDate)) {
				this.maxDate = capDate.toDate();
				console.log('Capping max date to one year from entered date - ', capDate.toDate());
			}
		}
	}

	async calendarRun() {
		this.loadingCalendar = !this.showCalendar && this.isGroupCitizenship();
		if (this.loadingCalendar) {
			this.spinner.show();
		}
		let serviceAvailability;
		if (typeof this.minDate === 'undefined') {
			this.prepareDates();
		}

		let resource_id = false;
		if (this.datastoreService.selectedResource) {
			resource_id = this.datastoreService.selectedResource.id;
		}

		// Get the available times for a service
		if (this.component) {

			serviceAvailability =
				await this.availabilityService.requestAvailableDaysAppointments(
					this.location,
					this.service,
					this.minDate.toISOString().split('T')[0],
					this.maxDate.toISOString().split('T')[0],
					resource_id
				);
		} else {
			serviceAvailability =
				await this.availabilityService.requestAvailableDaysServiceAppointments(
					this.location,
					this.service,
					this.minDate.toISOString().split('T')[0],
					this.maxDate.toISOString().split('T')[0],
					resource_id
				);
		}

		const currentDay = moment().format('dddd');
		const currentHour = parseInt(moment().format('HH'));
		const currentDayFormat = moment().format('YYYY-MM-DD');
		const currentDate = moment();

		if (this.death_service) {
			let counter = 0;
			if (currentDay === 'Friday' && currentHour >= 12) {
				for (const d of serviceAvailability.days) {
					const foundDate = moment(d.date);
					if (
						foundDate.startOf('d').diff(currentDate.startOf('d'), 'd') === 1
					) {
						serviceAvailability.days[counter].spaces = 0;
						serviceAvailability.days[counter].fully_booked = true;
						break;
					}
					counter++;
				}
			}

			counter = 0;
			if (currentDay === 'Saturday' || currentDay === 'Sunday') {
				const nextMonday = moment(currentDate)
					.add(1, 'week')
					.startOf('week')
					.startOf('d');
				for (const d of serviceAvailability.days) {
					const foundDate = moment(d.date);
					if (foundDate.startOf('d').isBefore(nextMonday)) {
						serviceAvailability.days[counter].spaces = 0;
						serviceAvailability.days[counter].fully_booked = true;
					}
					counter++;
				}
			}
		}
		console.log(serviceAvailability.days);

		// Set the available times so we do have to keep sending the same request
		await this.availabilityService.setAvailableDays(serviceAvailability.days);

		// If service availability contains data then filter the days that are available
		if (serviceAvailability.days && serviceAvailability.days.length > 0) {
			// Get the available days
			this.availableDays = serviceAvailability.days.filter(
				(day) => day.spaces > 0
			);
		} else {
			this.alertService.error(
				this.translateService.instant('COMMON.NO_AVAILABILITY')
			);
		}

		// If the selected date has been store in datastore then pre populate the selection
		if (this.selectedSlot) {
			let slotDate = new Date();
			if (this.selectedSlot.hasOwnProperty('start')) {
				slotDate = this.selectedSlot.start;
			} else {
				slotDate = this.selectedSlot;
			}
			if (this.isGroupCitizenship()) {
				await this.checkMonth(moment(slotDate).format('YYYY-MM'));
			}
			await this.updateSlots(new Date(slotDate));
		} else {
			if (this.isGroupCitizenship()) {
				await this.checkUntilOpen();
			}
			// For other services nothing is marked full, so this is availableDays.
			const openDays = this.openDays();
			if (openDays.length > 0) {
				await this.updateSlots(new Date(openDays[0].date));
			} else {
				if (this.availableDays?.length > 0) {
					// JRNI offered days, but every group session on them is full.
					this.alertService.error(this.translateService.instant('COMMON.NO_AVAILABILITY'));
				}
				await this.updateSlots(new Date());
			}
		}
		if (this.isGroupCitizenship()) {
			// Open the calendar on the month of the chosen day, not on today's month.
			this.startDate = this.selectedDate;
			// Redraws the days if the calendar is already on screen, for example after a venue change.
			this.calendar?.updateTodaysDate();
		}
		if (this.slots.length > 0) {
			if (!this.adminJourney) {
				if (
					!moment(this.slots[0].start).isBetween(this.minDate, this.maxDate)
				) {
					if (
						this.birth_registration_service ||
						this.birth_declaration_service
					) {
						this.calendarError =
							'As the birth occurred more than 42 days ago you will need to contact us via www.lincolnshire.gov.uk/comments-feedback/contact-us in order to arrange this appointment.';
					}
					if (this.death_service || this.death_declaration_service) {
						// this.calendarError = "As the death occurred more than 10 days ago you will need to contact us via www.lincolnshire.gov.uk/comments-feedback/contact-us in order to arrange this appointment."
						this.calendarError =
							"There are no self-service appointments currently available to be booked, but your appointment is extremely important to us. Please contact us via www.lincolnshire.gov.uk/comments-feedback/contact-us so we can urgently book your appointment. It is a legal requirement for all deaths to be registered within 5 days of the Medical Examiner's Office contacting you.";
					}
					if (this.marriage_service) {
						this.calendarError =
							'As the ceremony will occur outside of our 35 days to 6 months kin advance booking window you will need to contact us via www.lincolnshire.gov.uk/comments-feedback/contact-us in order to arrange this appointment.';
					}
				} else {
					if (!this.selectedSlot) {
						// console.log('selecting first slot');
						// this.selectSlot(this.slots[0]);
					} else {
						const slot = this.slots.find((slot) =>
							moment(slot.start).isSame(moment(this.selectedSlot.start))
						);
						console.log('slot found: ', slot);
						if (slot) {
							this.selectSlot(slot);
						}
					}
				}
			} else {
				// admin override
				this.calendarError = undefined;
				this.selectSlot(this.slots[0]);
			}
		} else {
			if (
				this.death_service &&
				currentDay !== 'Saturday' &&
				currentDay !== 'Sunday'
			) {
				this.calendarError =
					"There are no self-service appointments currently available to be booked, but your appointment is extremely important to us. Please contact us via www.lincolnshire.gov.uk/comments-feedback/contact-us so we can urgently book your appointment. It is a legal requirement for all deaths to be registered within 5 days of the Medical Examiner's Office contacting you.";
			}
		}
		this.showCalendar = true;
		this.loadingCalendar = false;
		this.spinner.hide();
	}

	// Check if the date is unavailable and if so return false
	unavailableDates = (date: Date): boolean => {
		const momentDate = moment(date);
		if (this.availableDays) {
			return (
				this.availableDays.some((day) => momentDate.isSame(day.date)) &&
				!this.citizenshipPlaces.isDayFull(momentDate.format('YYYY-MM-DD'))
			);
		} else {
			return false;
		}
	};

	// RPD-119: keep the earliest slot the customer was offered. The calendar loads the first
	// open day itself, so take the value from that first load and ignore later day clicks.
	// A new service, location or resource starts again.
	private recordFirstSlot() {
		const key = `${this.service?.id}:${this.location?.id}:${this.datastoreService.selectedResource?.id}`;
		if (this.slots[0] && this.datastoreService.firstSlotAnalyticKey !== key) {
			this.datastoreService.firstSlotAnalytic = this.slots[0].start;
			this.datastoreService.firstSlotAnalyticKey = key;
		}
	}

	// Date selected on calendar
	async updateSlots(date) {
		this.spinner.show();
		// add two hours onto the date so when we convert with iso it always keeps the same date
		date.setHours(date.getHours() + 2);

		// Update the selected date
		this.selectedDate = date;

		// slice time off
		const isoTime = date.toISOString().slice(0, -1).split('T')[0];

		const params = this.timesParams(isoTime, isoTime);
		const run = ++this.slotsRun;
		console.log('calculated_duration', this.service.calculated_duration, this.datastoreService.extraDuration);

		// let wheelChairAccess = false;

		// if (this.datastoreService.companyQuestionsForm) {
		//   wheelChairAccess = this.datastoreService.companyQuestionsForm.controls[277].value.toLowerCase().includes("yes") ? true : false;
		// }

		// Only add slots with availability
		const currentDate = moment();
		const res = await this.availabilityService.getSlots(this.location, params);
		if (run !== this.slotsRun) {
			// The customer picked another day while this one loaded.
			return;
		}
		let slots = [];
		if (res) {
			// if (wheelChairAccess) {
			// @TODO - rework this using a slot call per resource
			// const wcLocations = this.departmentService.getAccessibleLocations();
			// for (let staff of res['_embedded'].events) {
			//   let staffEvents = [];
			//   if (wcLocations.length > 0) {
			//     for (let l of wcLocations) {
			//       if (l.id == staff.resource_id) {
			//         staffEvents = staff.times;
			//       }
			//     }
			//   }
			//   staff.times = staffEvents;
			// }
			// }

			this.selectedSlot = undefined;
			this.availabilityService.setSelectedSlot(undefined);

			if (this.calendar && (res['times'] || []).some((time) => this.isOfferedTime(time))) {
				this.calendar._goToDateInView(this.selectedDate, 'month');
			}
			slots = this.bookableTimes(res['times']);
		}

		if (this.isGroupCitizenship()) {
			await this.citizenshipPlaces.loadSessions(slots.map((slot) => slot.start), this.location, this.service);
			if (run !== this.slotsRun) {
				return;
			}
			slots = slots.filter((slot) => !this.citizenshipPlaces.isSessionFull(slot.start));
		}
		this.slots = slots;

		// death rule filter
		if (this.death_service) {
			if (moment(date).startOf('d').isSame(moment(currentDate).startOf('d'))) {
				// SHOWING TODAY
				this.slots = this.slots.filter((x) =>
					moment(x.start).isSameOrAfter(
						moment(currentDate).add(3, 'h').add(30, 'minute')
					)
				);
			}
		}

		console.log(this.slots);

		this.recordFirstSlot();
		console.log(`first available slot: ${this.datastoreService.firstSlotAnalytic}`);
		this.spinner.hide();
	}

	/** The JRNI times query, shared by the day view and the month check so both see the same sessions. */
	private timesParams(startDate: string, endDate: string) {
		this.service.calculated_duration =
			Number(this.datastoreService.extraDuration) +
			Number(this.service.durations[0]);
		const params = {
			service_id: this.service.id,
			start_date: startDate,
			end_date: endDate,
			duration: this.service.calculated_duration,
		};

		if (this.datastoreService.selectedResource) {
			params['resource_id'] = this.datastoreService.selectedResource.id;
		}

		if (this.datastoreService.staff_set) {
			params['person_id'] = this.datastoreService.staff_set;
		}
		return params;
	}

	/** A time JRNI returned that the calendar would show. Group citizenship shows times JRNI calls unavailable. */
	private isOfferedTime(time): boolean {
		return !!this.datastoreService.groupCitizenshipBooking || time.available || this.isPreSelectedSlot(time.start);
	}

	/** The times the calendar offers from one JRNI times response. */
	private bookableTimes(times: any[]): any[] {
		const currentDate = moment();
		const currentDay = currentDate.format('dddd');
		const isWeekend = currentDay === 'Saturday' || currentDay === 'Sunday';
		const nextMonday = moment(currentDate).add(1, 'week').startOf('week').startOf('d');
		const filterTime = moment(currentDate).add(1, 'week').startOf('week');

		// At the weekend, times up to and including next Monday are only offered from next Monday.
		const passesWeekendRule = (time) => {
			if (!isWeekend) {
				return true;
			}
			const slotTime = moment(time.start);
			const isUpToNextMonday = moment(slotTime).startOf('d').isSameOrBefore(nextMonday);
			return !isUpToNextMonday || slotTime.isSameOrAfter(filterTime);
		};

		const slots = (times || [])
			.filter((time) => this.isOfferedTime(time))
			.filter(passesWeekendRule)
			// give all timeslots a london timezone and sort
			.map((slot) => ({
				...slot,
				displayTime: moment.utc(slot.start).tz('Europe/London').format('HH:mm'),
			}));
		slots.sort((a, b) => a.time - b.time);

		return slots
			// Remove dupes from different staff
			.filter((slot, index, self) => index === self.findIndex((t) => t.start === slot.start))
			// Remove slots if they are past the minDate (20 minutes before any booking)
			.filter((x) => new Date(x.start) > this.minDate);
	}

	private isGroupCitizenship(): boolean {
		return !!(this.datastoreService.isCitizenshipRoute && this.datastoreService.groupCitizenshipBooking);
	}

	/** The days JRNI offers, without the ones where every group session is full. */
	private openDays() {
		return (this.availableDays || []).filter((day) => !this.citizenshipPlaces.isDayFull(String(day.date).slice(0, 10)));
	}

	/** Checks the group sessions in a month (YYYY-MM). A month already checked sends no requests. */
	private checkMonth(month) {
		const sessions = this.citizenshipPlaces.hasChecked(month) ? undefined : this.sessionsForMonth(month);
		return this.citizenshipPlaces.checkMonth(month, sessions, this.location, this.service);
	}

	/** Checks one month after another until one has a day with room, so the calendar can open on it. */
	private async checkUntilOpen() {
		const months = Array.from(new Set<string>((this.availableDays || []).map((day) => String(day.date).slice(0, 7)))).sort();
		for (const month of months) {
			await this.checkMonth(month);
			if (this.openDays().some((day) => String(day.date).startsWith(month))) {
				return;
			}
		}
	}

	/** The bookable session start times on each day JRNI offers in a month, keyed YYYY-MM-DD. */
	private async sessionsForMonth(month) {
		const location = this.location;
		const days = Array.from(new Set<string>((this.availableDays || []).map((day) => String(day.date).slice(0, 10))))
			.filter((day) => day.startsWith(month))
			.sort();

		const sessions = new Map<string, string[]>();
		// Six days at a time, the most a browser sends to one host at once.
		for (let i = 0; i < days.length; i += 6) {
			const batch = days.slice(i, i + 6);
			const responses = await Promise.all(batch.map((day) => this.availabilityService.getSlots(location, this.timesParams(day, day))));
			batch.forEach((day, index) => {
				const times = responses[index]?.['times'];
				// If the times call failed we leave the day out, so it is never mistaken for a full day.
				if (Array.isArray(times)) {
					sessions.set(day, this.bookableTimes(times).map((time) => time.start));
				}
			});
		}
		return sessions;
	}

	/** When the customer moves to a month not checked yet, checks it with the spinner up so no day is picked too early. */
	private async onMonthChange() {
		if (this.destroyed || !this.isGroupCitizenship() || this.calendar?.currentView !== 'month') {
			return;
		}
		const month = moment(this.calendar.activeDate).format('YYYY-MM');
		if (this.citizenshipPlaces.hasChecked(month)) {
			return;
		}
		this.spinner.show();
		await this.checkMonth(month);
		this.spinner.hide();
		// The date filter only runs again when the month view is rebuilt.
		this.calendar?.updateTodaysDate();
	}

	isPreSelectedSlot(time: string) {
		const selectedSlotTime = this.selectedSlot?.start || this.selectedSlot;
		console.log('preSelectedTime: ', selectedSlotTime);

		if (selectedSlotTime && moment(selectedSlotTime).isSame(moment(time))) {
			console.log('found pre selected slot: ');
			console.log(selectedSlotTime);
			return true;
		}

		return false;
	}

	// Set the slot
	async selectSlot(slot) {
		this.spinner.show();
		slot.start = slot.start.split('+')[0];
		console.log('slot', slot);
		this.alertService.clear();
		let canContinue = true;
		if (this.datastoreService.isCitizenshipRoute) {
			if (this.datastoreService.groupCitizenshipBooking) {
				const attendeesAnswer = citizenshipAttendeesAnswer(this.datastoreService.selectedSchema);
				console.log('how_many_attendees_and_their_details_including_if_adult_or_child', attendeesAnswer);
				const availability: any = await this.apiService.citizenshipAvailability(this.location.id, this.service.id, slot.start);
				console.log('availability', availability);
				this.citizenshipPlaces.remember(slot.start, availability);
				// The form-builder stores this answer as a plain scalar, so reading `.value` off
				// it was always undefined: parseInt(undefined) is NaN, `NaN > slots` is false,
				// and the party size was never actually compared — only a response with no
				// places left blocked the slot. The derivation now lives in
				// citizenship-capacity.ts, which the summary-page re-check reads from too.
				const selectedSpaces = citizenshipPartySize(attendeesAnswer).places;
				console.log('selectedSpaces', selectedSpaces, 'slots', availability?.slots);
				if (!hasCapacityForParty(availability, selectedSpaces)) {
					this.availabilityService.setSelectedSlot(undefined);
					this.selectedSlot = undefined;
					canContinue = false;
					slot.available = false;
					this.spinner.hide();
					this.alertService.error(this.translateService.instant('COMMON.CITIZENSHIP_NOT_ENOUGH_SPACES', { spaces: availableSlotsForDisplay(availability) }));
					this.scrollToTop();
				}
			}
		}
		this.spinner.hide();
		if (canContinue) {
			this.selectedSlot = slot;
			this.availabilityService.setSelectedSlot(slot);
			this.selectSlotUpdate.emit(slot);
			// set end slot time
			const endSlot = slot.start;
			this.endTime = moment(endSlot).add(30, 'm').toDate();
			this.availabilityService.setEndSlot(this.endTime);
			console.log('this.datastoreService.isCitizenshipRoute', this.datastoreService.isCitizenshipRoute);
			if (this.datastoreService.isCitizenshipRoute) {
				try {
					const startTime = moment(slot.start);
					let citizenshipKey = 'mon_fri_9_5';
					console.log('day', startTime.day(), 'time', startTime.hour());
					const slotDay = startTime.day();
					const slotHour = startTime.hour();
					if (slotDay >= 1 && slotDay <= 5) {
						console.log('week day');
						if (slotHour > 16 || slotHour < 9) {
							console.log('out of hours');
							citizenshipKey = 'mon_fri_after_5';
						}
					}
					else {
						if (slotDay === 6) {
							citizenshipKey = 'sat';
						}
						if (slotDay === 0) {
							citizenshipKey = 'sun';
						}
					}

					console.log('citizenshipKey', citizenshipKey);
					this.datastoreService.citizenshipKey = citizenshipKey;
					const citizenshipFeeType = this.datastoreService.familyCitizenshipBooking ? 'family' : 'individual';
					const citizenshipFeeGroup = this.datastoreService.groupCitizenshipBooking ? 'group' : 'private';
					const fallbackCitizenshipFees = this.datastoreService.groupCitizenshipBooking ? this.datastoreService.citizenshipGroupFees : this.datastoreService.citizenshipFees;
					// The fee id in journey_config.appointments.citizenshipFees wins. If config has no id for this band and type, use the hard-coded id.
					const citizenshipExtraItemId = this.config?.journey_config?.appointments?.citizenshipFees?.[citizenshipFeeGroup]?.[citizenshipKey]?.[citizenshipFeeType]
						?? fallbackCitizenshipFees[citizenshipKey][citizenshipFeeType];
					console.log('citizenshipExtraItemId', citizenshipExtraItemId, this.selectedLocation, this.service);
					const citizenshipExtraItem: any = await this.apiService.getExtraItem(this.service.company_id, this.service.id, citizenshipExtraItemId);
					console.log('citizenshipExtraItem', citizenshipExtraItem);
					this.datastoreService.citizenshipExtraItem = citizenshipExtraItem;
					if (!this.datastoreService.serviceFees) {
						this.datastoreService.serviceFees = [];
					}
					this.datastoreService.serviceFees.push({
						questionid: undefined,
						item: this.service.name,
						quantity: 1,
						cost: citizenshipExtraItem.item_price,
						deposit: citizenshipExtraItem.item_price,
					});
				}
				catch (err) {
					console.error(err);
				}
			}
		}
		this.spinner.hide();

		// this.datastoreService.selectedSlot =
		// 	this.availabilityService.getSelectedSlot()['__zone_symbol__value'];
		// console.log('setting selected slot: ', this.datastoreService.selectedSlot);
	}

	emitNextClicked() {
		this.nextClicked.emit();
	}

	scrollToTop() {
		window.scroll(0, 0);
	}
}
